import React, { CSSProperties } from 'react'

import { Link } from '@material-ui/core'

import { BRAND, BRANDS } from '~/brands'

const linksConfig = {
  [BRANDS.boat]: {
    title: 'Credit One',
    url:
      'https://www.creditone.com.au/quick-quote?dealer_name=trade-a-boat&utm_source=dealer&utm_medium=referral&utm_campaign=dealer_application_form&utm_keywords=quick-quote'
  },
  [BRANDS.rv]: {
    title: 'Credit One',
    url:
      'https://www.creditone.com.au/quick-quote?dealer_name=trade-rvs&utm_source=dealer&utm_medium=referral&utm_campaign=dealer_application_form&utm_keywords=quick-quote'
  }
}

interface BlogExternalLinkProps {
  href: string
  title?: string
  style?: CSSProperties
}

const BlogExternalLink = ({ href, title, style }: BlogExternalLinkProps) => {
  const isFinleaseLink = href.includes('finlease')

  const currentLink = isFinleaseLink ? linksConfig[BRAND].url : href
  const currentTitle = isFinleaseLink ? linksConfig[BRAND].title : title
  const currentText = isFinleaseLink ? linksConfig[BRAND].title : href

  return (
    <Link
      component="a"
      href={currentLink}
      target="_blank"
      rel="noreferrer"
      title={currentTitle}
      style={style}
    >
      {currentText}
    </Link>
  )
}

export default BlogExternalLink
